import { Component, Inject, OnInit, Optional } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiServiceService } from 'src/app/api-service.service';

@Component({
    selector: 'app-password-reset-modal',
    templateUrl: './password-reset-modal.component.html',
    styleUrls: ['./password-reset-modal.component.scss'],
    standalone: false
})
export class PasswordResetModalComponent implements OnInit  {
  
  passwordForm: FormGroup;
  isTemp: boolean = true;
  isPassExpired:boolean = false;
  userName:string | undefined;
  hideOldPassword:boolean=true;
  hidePassword:boolean=true;
  hideConfirm:boolean=true;
  isWrong:boolean=false;
  constructor(
    public dialogRef: MatDialogRef<PasswordResetModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private apiService: ApiServiceService
  ) {
    this.isTemp = data?.isTempPass;
    this.isPassExpired = data?.isPassExpired;
    this.userName = data?.userName;
    this.passwordForm = this.fb.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', [
        Validators.required,
        Validators.minLength(12),
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=])(?!.*['"\\`;<>]).{12,}$/)
      ]],
      confirmPassword: ['', Validators.required]
    }, { validators: this.passwordMatchValidator });
}
  ngOnInit(): void {
    if (this.isTemp){
      this.passwordForm.get('oldPassword')?.clearValidators();
    }
  }

  passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
    const password = control.get('newPassword')?.value;
    const confirm = control.get('confirmPassword')?.value;
    return password === confirm ? null : { mismatch: true };
  }
  
  onSubmit() {
    if (this.passwordForm.valid) {
      const passData = { 
        isTemp: this.isTemp, 
        isPassExpired: this.isPassExpired, 
        employeeId:this.data?.employeeId, 
        userName: this.userName, 
        oldPassword: this.passwordForm.get('oldPassword')?.value,
        newPassword:this.passwordForm.get('confirmPassword')?.value
      };
      this.apiService.resetPassword(passData).subscribe((res:any)=>{
        if(res?.message === 'Failed'){
          this.isWrong = true;
        }else if(res?.message === 'Success'){
          this.isWrong = false;
          this.dialogRef.close(true);
        }
      })
    }
  }
}
